import Svg from '@app/components/svg';

export const EuFlag = Svg(
  <>
    <g clipPath="url(#clip0_798_68410)">
      <rect
        width="36"
        height="24"
        fill="#FF4E4E"
      />
      <path
        d="M36 0L0 0L0 24L36 24L36 0Z"
        fill="#003399"
      />
      <path
        d="M18.0014 2.66602L17.7018 3.58735H16.7334L17.517 4.15668L17.2178 5.07802L18.0014 4.50868L18.785 5.07802L18.4858 4.15668L19.2694 3.58735L18.301 3.58735L18.0014 2.66602Z"
        fill="#FFCC00"
      />
      <path
        d="M18.301 19.5873L18.0014 18.666L17.7018 19.5873H16.7334L17.517 20.1567L17.2178 21.078L18.0014 20.5087L18.785 21.078L18.4858 20.1567L19.2694 19.5873H18.301Z"
        fill="#FFCC00"
      />
      <path
        d="M10.0014 12.5087L10.785 13.078L10.4858 12.1567L11.2694 11.5873H10.301L10.0014 10.666L9.70184 11.5873H8.7334L9.51695 12.1567L9.21784 13.078L10.0014 12.5087Z"
        fill="#FFCC00"
      />
      <path
        d="M14.0014 3.73828L13.7018 4.65917H12.7334L13.517 5.22895L13.2178 6.15028L14.0014 5.5805L14.785 6.15028L14.4858 5.22895L15.2694 4.65917H14.301L14.0014 3.73828Z"
        fill="#FFCC00"
      />
      <path
        d="M11.0731 6.66602L10.7736 7.58735H9.80469L10.5887 8.15668L10.2891 9.07802L11.0731 8.50868L11.8567 9.07802L11.5571 8.15668L12.3411 7.58735H11.3722L11.0731 6.66602Z"
        fill="#FFCC00"
      />
      <path
        d="M11.3722 15.5873L11.0731 14.666L10.7736 15.5873H9.80469L10.5887 16.1567L10.2891 17.078L11.0731 16.5087L11.8567 17.078L11.5571 16.1567L12.3411 15.5873H11.3722Z"
        fill="#FFCC00"
      />
      <path
        d="M14.301 18.5151L14.0014 17.5938L13.7018 18.5151H12.7334L13.517 19.0849L13.2178 20.0062L14.0014 19.4364L14.785 20.0062L14.4858 19.0849L15.2694 18.5151H14.301Z"
        fill="#FFCC00"
      />
      <path
        d="M27.2694 11.5873H26.301L26.0014 10.666L25.7018 11.5873H24.7334L25.517 12.1567L25.2178 13.078L26.0014 12.5087L26.785 13.078L26.4858 12.1567L27.2694 11.5873Z"
        fill="#FFCC00"
      />
      <path
        d="M22.0014 3.73828L21.7018 4.65917H20.7334L21.517 5.22895L21.2178 6.15028L22.0014 5.5805L22.785 6.15028L22.4858 5.22895L23.2694 4.65917H22.301L22.0014 3.73828Z"
        fill="#FFCC00"
      />
      <path
        d="M24.4451 8.15668L24.1456 9.07802L24.9291 8.50868L25.7131 9.07802L25.4136 8.15668L26.1976 7.58735H25.2287L24.9291 6.66602L24.63 7.58735H23.6611L24.4451 8.15668Z"
        fill="#FFCC00"
      />
      <path
        d="M25.2287 15.5873L24.9291 14.666L24.63 15.5873H23.6611L24.4451 16.1567L24.1456 17.078L24.9291 16.5087L25.7131 17.078L25.4136 16.1567L26.1976 15.5873H25.2287Z"
        fill="#FFCC00"
      />
      <path
        d="M22.301 18.5151L22.0014 17.5938L21.7018 18.5151H20.7334L21.517 19.0849L21.2178 20.0062L22.0014 19.4364L22.785 20.0062L22.4858 19.0849L23.2694 18.5151H22.301Z"
        fill="#FFCC00"
      />
    </g>
    <defs>
      <clipPath id="clip0_798_68410">
        <rect
          width="36"
          height="24"
          fill="white"
        />
      </clipPath>
    </defs>
  </>,
  {
    viewBox: '0 0 36 24',
    fill: 'none',
  },
);

EuFlag.displayName = 'EuFlag';
